import forEach from 'dcode/functions/forEach'
import getPostLink from '@/functions/getPostLink'

export default function getRecommend (basic) {
  const recommend = []

  forEach(basic, item => {
    item.list.forEach(item => {
      if (item.recommend) {
        recommend.push({
          ...item,
          href: getPostLink(item, true),
          to: getPostLink(item)
        })
      }
    })
  })

  return recommend
}
